import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import CapMark from 'components/Global/ChatBubble/CapMark';
import { AI_MODEL_OPTIONS, findAiModel } from 'constants/aiModels';
import { setChatModel } from 'redux/slice/chatBubbleSlice';
import { AppDispatch } from 'redux/store';
import styles from './ModelPicker.module.scss';

const ChevronIcon = () => (
	<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">
		<path
			d="M6 9.5l6 6 6-6"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const CheckIcon = () => (
	<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">
		<path
			d="M5 12.5l4.5 4.5L19 7"
			fill="none"
			stroke="currentColor"
			strokeWidth="2.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

// Which Claude model answers. A dropdown rather than a row of buttons because
// the full product names carry their version, and three of those side by side
// would crowd the page header they sit in.
const ModelPicker = () => {
	const dispatch = useDispatch<AppDispatch>();
	const modelId = useSelector((state: any) => state?.chatBubble?.model);
	const active = findAiModel(modelId);

	const items: MenuProps['items'] = AI_MODEL_OPTIONS.map((option) => ({
		key: option.id,
		label: (
			<div className={styles['model-option']}>
				<span className={styles['model-option__check']}>
					{option.id === active.id ? <CheckIcon /> : null}
				</span>
				<span className={styles['model-option__text']}>
					<span className={styles['model-option__name']}>{option.fullLabel}</span>
					<span className={styles['model-option__desc']}>{option.description}</span>
				</span>
			</div>
		),
	}));

	return (
		<Dropdown
			trigger={['click']}
			placement="bottomRight"
			menu={{ items, onClick: ({ key }) => dispatch(setChatModel(key)) }}
			overlayClassName={styles['model-menu']}
		>
			<button type="button" className={styles['model-trigger']} aria-label={`Model: ${active.fullLabel}`}>
				<CapMark size={12} tone="dark" />
				{active.label}
				<ChevronIcon />
			</button>
		</Dropdown>
	);
};

export default ModelPicker;
